// import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { StyledDropdown } from "shared/dist/components";
import Box from "@mui/material/Box";
import { aiServiceDetailsActions } from "../../../../../../Services/Redux/actionCreators";
import { serviceTypes } from "../../../../../../Utils/serviceTypes";
import classes from "./ServiceType.module.css";

export const listServiceTypes = [
    { value: serviceTypes.GRPC, label: serviceTypes.GRPC },
    { value: serviceTypes.HTTP, label: serviceTypes.HTTP },
    { value: serviceTypes.JSONRPC, label: serviceTypes.JSONRPC },
    { value: serviceTypes.PROCESS, label: serviceTypes.PROCESS },
];

const ServiceType = ({ disabled }) => {
    const dispatch = useDispatch();
    const serviceType = useSelector((state) => state.aiServiceDetails.serviceType);
    // const [serviceType, setServiceType] = useState(serviceTypeValue);

    const chooseServiceType = (event) => {
        const newServiceTypeValue = event.target.value;
        if (newServiceTypeValue === serviceType) {
            return;
        }
        // setServiceType(newServiceTypeValue);
        dispatch(aiServiceDetailsActions.setAiServiceType(newServiceTypeValue));
    };

    return (
        <Box className={classes.serviceTypeContainer}>
            <StyledDropdown
                name="model_type"
                inputLabel="Choose type of your service"
                value={serviceType}
                list={listServiceTypes}
                onChange={chooseServiceType}
                disabled={disabled}
            />
        </Box>
    );
};

export default ServiceType;
